import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ name: '首页', path: '/' }];

  if (pathParts[0] === 'category' && pathParts[1]) {
    const catNames: Record<string, string> = {
      action: '动作', comedy: '喜剧', romance: '爱情', scifi: '科幻',
      horror: '恐怖', animation: '动画', drama: '剧情', suspense: '悬疑',
      documentary: '纪录片',
    };
    items.push({ name: catNames[pathParts[1]] || pathParts[1] });
  } else if (pathParts[0] === 'article') {
    items.push({ name: '影视详情' });
  } else if (pathParts[0] === 'about') {
    items.push({ name: '关于我们' });
  }

  if (items.length <= 1) return null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.path ? `https://www.tianmeiys.com${item.path}` : undefined,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <nav className="w-full px-4 md:px-6 py-3" aria-label="面包屑导航">
        <div className="max-w-7xl mx-auto">
          <ol className="flex items-center gap-1.5 text-xs text-foreground-400">
            {items.map((item, idx) => (
              <li key={idx} className="flex items-center gap-1.5">
                {idx > 0 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
                {item.path && idx < items.length - 1 ? (
                  <Link to={item.path} className="hover:text-primary-500 transition-colors">
                    {item.name}
                  </Link>
                ) : (
                  <span className="text-foreground-500 font-medium">{item.name}</span>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </>
  );
}